import moment from 'moment';

const interestRateMonthly = interestRate => interestRate > 0 ? interestRate / 12 : 0;

export function payment({
  INTEREST_RATE, PRINCIPLE, DOWNPAYMENT, TERM = 1, MODIFY_TERM = 0, PAYMENT_DATA
}) {
  if (INTEREST_RATE === 0) return (PRINCIPLE - DOWNPAYMENT) / PAYMENT_DATA.length;
  //  let term = PAYMENT_DATA.length !== 0 ? PAYMENT_DATA.length : 10
  const top = interestRateMonthly(INTEREST_RATE) * (PRINCIPLE - DOWNPAYMENT);
  const bottom = 1 - ((1 + interestRateMonthly(INTEREST_RATE)) ** (-1 * (TERM)));
  return top / bottom;
}

export function term({
  INTEREST_RATE, PRINCIPLE, DOWNPAYMENT, PAYMENT,
}) {
  if (INTEREST_RATE === 0) return Math.ceil((PRINCIPLE - DOWNPAYMENT) / PAYMENT);
  const top = -1 * Math.log(1 - (interestRateMonthly(INTEREST_RATE)
    * (PRINCIPLE - DOWNPAYMENT)) / PAYMENT);
  const bottom = Math.log(1 + interestRateMonthly(INTEREST_RATE));
  return (top / bottom);
}

export function principleByPaymentNumber(state) {
  if (state.INTEREST_RATE === 0 && state.PAYMENT_NUMBER === 0) return (state.PRINCIPLE - state.DOWNPAYMENT);
  if (state.INTEREST_RATE === 0) return (state.PRINCIPLE - state.DOWNPAYMENT) - (payment(state) * state.PAYMENT_NUMBER);
  const section1 = (state.PRINCIPLE - state.DOWNPAYMENT)
    * ((1 + interestRateMonthly(state.INTEREST_RATE))
      ** state.PAYMENT_NUMBER);
  const section2 = state.PAYMENT / interestRateMonthly(state.INTEREST_RATE);
  const section3 = ((1 + interestRateMonthly(state.INTEREST_RATE)) ** (state.PAYMENT_NUMBER)) - 1;
  return (section1 - (section2 * section3));
}


export function principleAt(state) {
  // simple case just do the math !!  (rate of change is constant)
  if (state.ANNUAL_PAYMENT_AMOUNT === 0
    && state.ONE_TIME_PAYMENT_AMOUNT === 0
    && state.EXTRA_MONTHLY_PAYMENT_AMOUNT === 0) {
    return principleByPaymentNumber(state);
  }

  // complex case... we need to caclulate the
  // principle month by month because the rate of change fluctates
  let next = state.balance;
  next -= (state.PAYMENT - next * interestRateMonthly(state.INTEREST_RATE));


  if (state.EXTRA_MONTHLY_PAYMENT_AMOUNT > 0) {
    next -= state.EXTRA_MONTHLY_PAYMENT_AMOUNT;
  }
  const currentMoment = moment(state.START_DATE).add(state.PAYMENT_NUMBER - 1, 'months');


  if (currentMoment.diff(state.ONE_TIME_PAYMENT_DATE, 'months') === 0) {
    next -= state.ONE_TIME_PAYMENT_AMOUNT;
  }
  if (state.ANNUAL_PAYMENT_DATE === currentMoment.format('MMMM')) {
    next -= state.ANNUAL_PAYMENT_AMOUNT;
  }
  return next;
}

export function monthlyInterestAfterNumPayments(state) {
  const balance = state.balance ? state.balance : principleAt(state);
  if (state.PAYMENT_NUMBER && state.PAYMENT_NUMBER === 0) return 0;
  return interestRateMonthly(state.INTEREST_RATE) * balance;
}

export function totalInterestAfterNumPayments(state) {

  let interest = 0;
  for (let n = 0; n <= state.PAYMENT_NUMBER; n += 1) {
    interest += monthlyInterestAfterNumPayments({ ...state, PAYMENT_NUMBER: n });
  }
  return interest;
}


export function monthlyPrincipleAfterNumPayments(state) {

  return state.PAYMENT - monthlyInterestAfterNumPayments(state);
}

export function paidPrincipleByPaymentNumber(state) {
  //if (state.PAYMENT_NUMBER && state.PAYMENT_NUMBER === 0) return 0;
  const balance = state.balance ? state.balance : principleAt(state);
  return state.PRINCIPLE - state.DOWNPAYMENT - balance;
}


export function buildPaymentItem(state, balance, currentPayment,
  monthlyInterest, interest, monthlyPrinciple) {

  // if (currentPayment === 0) {
  //   monthlyInterest = 0
  //   monthlyPrinciple = 0;
  //   interest = 0;
  // }
  return {
    balance,
    monthlyInterest,
    monthlyPrinciple,
    interest,
    principle:
      paidPrincipleByPaymentNumber({ ...state, balance, PAYMENT_NUMBER: currentPayment }),
    date:
      moment(state.START_DATE).add(currentPayment, 'month'),
    payment: state.PAYMENT
  };
}

function emptyPaymentData(state) {

  return state.PAYMENT_DATA.map(item => [{  //downpayment cannot be greater than principle
    balance: 0,
    monthlyInterest: 0,
    monthlyPrinciple: 0,
    interest: 0,
    principle: 0,
    date: moment(state.START_DATE),
    payment: 1,
  }]);
}

export function buildPaymentData(state) {
  const data = [];
  let currentPayment = 0;
  let balance = state.PRINCIPLE - state.DOWNPAYMENT;
  if (balance < 0) return emptyPaymentData(state);

  let interest = 0;
  while (balance > 0) {
    const monthlyInterest = monthlyInterestAfterNumPayments({
      ...state, balance, PAYMENT_NUMBER: currentPayment,
    });
    interest += monthlyInterest;
    balance = principleAt({ ...state, balance, PAYMENT_NUMBER: currentPayment + 1 });

    const monthlyPrinciple = state.PAYMENT - monthlyInterest;
    data.push(
      buildPaymentItem(state, balance, currentPayment,
        monthlyInterest, interest, monthlyPrinciple),
    );
    currentPayment += 1;
  }


  if (balance < 0) {
    if (data[0].balance < 0) return emptyPaymentData(state);
    data.pop();
    currentPayment -= 1;
    const monthlyInterest = data[data.length - 1].balance
      * interestRateMonthly(state.INTEREST_RATE);
    const monthlyPrinciple = data[data.length - 1].balance;
    interest = data[data.length - 1].interest + monthlyInterest;
    const principle = data[data.length - 1].principle + balance;
    data[data.length] = ({
      balance: 0,
      monthlyInterest,
      monthlyPrinciple,
      interest,
      principle,
      date: moment(state.START_DATE).add(data.length, 'months'),
      payment: monthlyPrinciple + monthlyInterest,
    });
  }

  return data;
}
